import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useOnboarding } from './OnboardingProvider';
import { EditHighlightsForm } from '../cv/forms/EditHighlightsForm';
import { OnboardingWebStep } from './web-step-chrome';

/**
 * Career highlights: an OPTIONAL CV section (not part of the linear flow). It's
 * normally reached from the CV preview / checklist (Back and Save return
 * there); in the manual-build wizard it joins the linear flow, where the same
 * resolver calls advance to the next section instead. No progress bar.
 */
export function StepHighlights() {
  const { t } = useTranslation('auth');
  const { nextStep, prevStep } = useOnboarding();
  // Off-flow (preview editor): the resolvers return to 'complete'. In the
  // manual-build wizard this step IS in the flow, so the same calls advance
  // linearly instead — see onboarding-navigation.ts.
  const advance = useCallback(() => void nextStep(), [nextStep]);
  const goBack = useCallback(() => void prevStep(), [prevStep]);

  return (
    <OnboardingWebStep
      titleBase={t('onboarding.highlights.titleBase', { defaultValue: 'Add your' })}
      titleAccent={t('onboarding.highlights.titleAccent', { defaultValue: 'highlights' })}
      subtitle={t('onboarding.highlights.subtitle', { defaultValue: 'Your proudest career moments' })}
      onBack={goBack}
    >
      <EditHighlightsForm
        onSave={advance}
        closeOnSave={false}
        ctaLabel={t('onboarding.done', { defaultValue: 'Done' })}
        sparkApplySkill={false}
      />
    </OnboardingWebStep>
  );
}
